import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import JudgeTable from "./JudgeTable";
import HubbleRequests from "services/hubble";
import { Box } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { AddBox } from "@material-ui/icons";
import AddJudgeAccess from "./AddJudgeAccess";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
}));

const JudgeContainer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openAddDialog, setOpenAddDialog] = useState(false);

  useEffect(() => {
    dispatch(HubbleRequests.getJudgeList());
  }, []);

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardContent className={classes.cardContentRoot}>
        <Box>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<AddBox />}
            onClick={() => setOpenAddDialog(true)}
            style={{ marginRight: 14, marginBlock: "10px" }}
          >
            اضافه کردن داور
          </Button>
        </Box>
        <JudgeTable />
      </CmtCardContent>
      <AddJudgeAccess
        open={openAddDialog}
        handleClose={() => setOpenAddDialog(false)}
      />
    </CmtCard>
  );
};

export default JudgeContainer;
